import styled from "styled-components";
import { SolidPrimaryBtn } from "./button/Button";
import { useNavigate } from "react-router-dom";
import { ReactComponent as NoDataSVG } from "assets/image/common/no-data.svg";

const NoDataWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1.25rem;
  p {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    color: ${({theme}) => theme.newTheme.default.textGray};
  }
  button {
    width: 13rem;
  }
`;

// 펭귄이미지와 데이터 없음 + 버튼
export function NoDataWithImageTextButton({ text, btnText, linkUrl }: { text: any; btnText: string; linkUrl: string; }) {
  const navigate = useNavigate();

  function goToPage(page: string) {
    navigate(`${page}`);
  }

  return (
    <NoDataWrap>
      <NoDataSVG />
      <p>
        {text.map((t: any, index: number) => (<span key={index}>{t.text}</span>))}
      </p>
      <SolidPrimaryBtn type="button" className="default-btn" onClick={() => goToPage(linkUrl)}>
        {btnText}
      </SolidPrimaryBtn>
    </NoDataWrap>
  );
}

// 펭귄이미지와 데이터 없음
export function NoDataWithImageText({ text }: { text: any }) {
  return (
    <NoDataWrap>
      <NoDataSVG />
      <p>
        {text.map((t: any, index: number) => (
          <span key={index}>{t.text}</span>
        ))}
      </p>
    </NoDataWrap>
  );
}
